import { makeStyles, createStyles } from '@material-ui/core/styles';

export default makeStyles(
  () =>
    createStyles({
      button: {
        fontSize: 16,
      },
      card: {
        width: 280,
      },
      list: {
        width: '100%',
      },
      item: {
        width: '100%',
      },
      text: {
        width: '100%',
        '& span': {
          fontFamily: '"Nunito", sans-serif',
          fontWeight: 300,
          fontSize: 16,
          width: '100%',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        },
      },
    }),
  { name: 'DuvidasNotificacao' }
);
